export type StatusVisibility = { accountIds: string[]; groupIds: string[] };

/** Multi-account contexts use a union. No context and empty scopes mean all. */
export function visiblePostStatuses<
  T extends { key: string; visibility?: StatusVisibility },
>(
  statuses: T[],
  {
    enabled,
    accountIds = [],
    groups = [],
    currentKeys = [],
  }: {
    enabled: boolean;
    accountIds?: string[];
    groups?: { _id: string; accountIds: string[] }[];
    currentKeys?: string[];
  }
): T[] {
  if (!enabled || !accountIds.length) return statuses;
  const relevantGroups = new Set(
    groups
      .filter((group) => group.accountIds.some((id) => accountIds.includes(id)))
      .map((group) => group._id)
  );
  const visible = statuses.filter((status) => {
    const visibility = status.visibility;
    return (
      currentKeys.includes(status.key) ||
      !visibility ||
      (!visibility.accountIds.length && !visibility.groupIds.length) ||
      visibility.accountIds.some((id) => accountIds.includes(id)) ||
      visibility.groupIds.some((id) => relevantGroups.has(id))
    );
  });
  // Effective Basic catalogs carry projection metadata on their array identity.
  return visible.length === statuses.length ? statuses : visible;
}
